/* eslint-disable no-unused-vars */
import { helper } from '@ember/component/helper';

export default helper(function sectionComponents([section]) {
  if (!section) {
    return [];
  }
  let config = section.get
    ? section.get('configuration')
    : section.configuration;
  if (!config) {
    return [];
  }
  if (typeof config === 'string') {
    try {
      config = JSON.parse(config);
    } catch (e) {
      return [];
    }
  }
  return config.components || [];
});
